import { render, staticRenderFns } from "./BettingResult.vue?vue&type=template&id=75e0329a&scoped=true"
import script from "./BettingResult.vue?vue&type=script&lang=js"
export * from "./BettingResult.vue?vue&type=script&lang=js"
import style0 from "./BettingResult.vue?vue&type=style&index=0&id=75e0329a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e0329a",
  null
  
)

export default component.exports